"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(number) {
  return number && [5, 6].includes(+number.substr(0, 1));
}